export const ORGANIZATION_TRUST = {
  name: "Nalosoft",
  url: "https://nalosoft.com",
  logoUrl: "https://nalosoft.com/logo.png",
  cvrNumber: "39802880",
  vatId: "DK39802880",
  foundingYear: "2018",
} as const;

export const TRUST_FACTS = [
  { id: "studio", icon: "mdi:map-marker-star-outline" },
  { id: "founded", icon: "mdi:calendar-check-outline" },
  { id: "cvr", icon: "mdi:identifier" },
  { id: "seniorCollaboration", icon: "mdi:account-tie-outline" },
  { id: "fixedScope", icon: "mdi:package-variant-closed-check" },
  { id: "care", icon: "mdi:shield-check-outline" },
] as const;

export type TrustFactId = (typeof TRUST_FACTS)[number]["id"];

export function getTrustFactLabel(
  t: (key: string, options?: Record<string, string>) => string,
  id: TrustFactId
) {
  if (id === "founded") {
    return t("facts.founded", { year: ORGANIZATION_TRUST.foundingYear });
  }

  if (id === "cvr") {
    return t("facts.cvr", { cvr: ORGANIZATION_TRUST.cvrNumber });
  }

  return t(`facts.${id}`);
}
